<template>
  <div class="cursor-pointer ">
    <span 
      class="inline-block
      text-xs
      lg:text-base
      px-2
      lg:px-6
      py-0
      lg:py-2
      mr-1
      lg:mr-2
      rounded-full
      uppercase
      font-semibold
      tracking-wide
      select-none"
      :class="bgcolor">  
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    bgcolor: {
      type: String,
      default: "bg-gray-300 text-gray-600 active:bg-gray-400 active:text-gray-900"
    },
  },

}
</script>